import React, { useState } from "react";
import "./EventsPage.css";
import events from "../../Data/eventsData"; // central events list

const EventsPage = () => {
  const [activeFilter, setActiveFilter] = useState("All");

  // sort by date (upcoming first)
  const sortedEvents = [...events].sort(
    (a, b) => new Date(a.date) - new Date(b.date)
  );

  // filter by type
  const filteredEvents =
    activeFilter === "All"
      ? sortedEvents
      : sortedEvents.filter((e) => e.type === activeFilter);

  return (
    <div className="eventContainer">
      {/* Filter Buttons */}
      <div className="eventButtons">
        {["All", "Jobs", "Webinar", "Seminar"].map((filter) => (
          <button
            key={filter}
            className={activeFilter === filter ? "active" : ""}
            onClick={() => setActiveFilter(filter)}
          >
            {filter}
          </button>
        ))}
      </div>

      {/* Jobs Section */}
      {(activeFilter === "All" || activeFilter === "Jobs") && (
        <div className="eventJobs">
          <h2>Jobs</h2>
          <div className="eventJobStartupBlock">
            {filteredEvents
              .filter((event) => event.type === "Jobs")
              .map((event) => (
                <div key={event.id} className="eventJobStartupCard">
                  <div className="eventJobStartupImg">
                    <img src={event.img} alt={event.title} />
                    <div className="eventJobStartupImg2">
                      <h3>{event.title}</h3>
                      <p>{event.location}</p>
                    </div>
                  </div>
                  <div className="eventJobStartupText">
                    <p>{event.desc}</p>
                    <p className="eventDate">📅 {event.date}</p>
                  </div>
                </div>
              ))}
          </div>
        </div>
      )}

      {/* Webinars Section */}
      {(activeFilter === "All" || activeFilter === "Webinar") && (
        <div className="eventWebinarText">
          <h2>Webinars</h2>
          <div className="eventWebinarBlock">
            {filteredEvents
              .filter((event) => event.type === "Webinar")
              .map((event) => (
                <div key={event.id} className="eventWebinarCard">
                  <img src={event.img} alt={event.title} />
                   
                  <div className="eventWebinarCardText">
                    <h3>{event.title}</h3>
                    <p>{event.desc}</p>
                    <p className="eventDate">
                      📅 {event.date} | 📍 {event.location}
                    </p>
                  </div>
                </div>
              ))}
          </div>
        </div>
      )}

      {/* Seminars Section */}
      {(activeFilter === "All" || activeFilter === "Seminar") && (
        <div className="eventWebinarText">
          <h2>Seminars</h2>
          <div className="eventWebinarBlock">
            {filteredEvents
              .filter((event) => event.type === "Seminar")
              .map((event) => (
                <div key={event.id} className="eventWebinarCard">
                   <img src={event.img} alt={event.title} />
                   
                  <div className="eventWebinarCardText">
                    <h3>{event.title}</h3>
                    <p>{event.desc}</p>
                    <p className="eventDate">
                      📅 {event.date} | 📍 {event.location}
                    </p>
                  </div>
                </div>
              ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default EventsPage;
